
<div class="container-fluid container-md">
    <div class="row ">
        <!-- LEFT SIDE BAR -->
        <div class="col-sm-2 col-md-3 d-flex flex-column text-sm-end text-md-start align-items-lg-start left_sidebar border-end">
            <app-left-sidebar [Username]="Username"
                              (postSubmitComplete)="getUserPostsDataNew(true)"
                              (postContent)="updatePostContent($event)"
                              (mediaUrlsChange)="updatePostMediaUrls($event)"
                              (replyTypeChange)="updateReplyType($event)"
                              (onSave)="savePost()">
            </app-left-sidebar>
        </div>

        <!-- MAIN SECTION -->
        <div class="col-12 col-sm-10 col-md-9 col-lg-6  main_bar " #mainContent>
            <div class="row d-flex justify-content-between align-items-center ps-1">
            </div>
            <div class="row mt-4">
                <div class="col pt-2 ">
                    <div class="row">

                        <div class="col-1 mt-2" style="display:table-cell !important;">
                            <div class="user-avatar-container-top">
                                <img class="circular-image" [src]="'api/content/logo?userID=' + UserID" (error)="onApiLogoError($event)" alt="">
                            </div>
                        </div>

                        <div class="col-11 ">
                            <!-- Post Content Input -->
                            <app-post-submit [Username]="Username"
                                             [UserID]="UserID"
                                             [pageType]="'postSubmitModal'"
                                             [mediaUrls]="mediaUrls"
                                             [selectedReplyType]="selectedReplyType"
                                             (postContent)="updatePostContent($event)"
                                             (removeMedia)="removeMediaFromFooter($event)">
                            </app-post-submit>

                            <!-- Footer for Media & Reply Options -->
                            <app-post-footer #footerComponent
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [hasPostText]="hasPostText"
                                             [pageType]="'Home'"
                                             (mediaUrlsChange)="updatePostMediaUrls($event)"
                                             (replyTypeChange)="updateReplyType($event)"
                                             (onSave)="savePost()">
                            </app-post-footer>

                        </div>
                    </div>
                    <div class="row  d-flex  justify-content-between align-items-center">
                        <div *ngFor="let postData of UserPostsData; let i = index" #postElement>
                            <div [id]="'post' + ((currentPage - 1) * pageSize + i)" class="post-container" (click)="navigateToPost(postData.UserName, postData.TSID)">

                                <app-post-detail (postEditedOrDeleted)="getUserPostsDataNew(true)"
                                                 [Username]="Username"
                                                 [UserID]="UserID"
                                                 [postData]="postData"
                                                 [pageType]="'dashboard'">
                                </app-post-detail>

                                <!--(mediaUrlsChange)="updatePostMediaUrls($event)"
                            (replyTypeChange)="updateReplyType($event)"
                            (postContent)="updatePostContentReactions($event)"
                            (onSaveReactions)="savePostReactions($event)"-->

                            </div>
                            <div *ngIf="isLoading">
                                Loading more posts...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- RIGHT SIDE BAR -->
        <div class="col-lg-3 d-none d-lg-block " >
            <div class="right_side_bar" #sidebar>
                <div class="sidebar-content" #sidebarContent>
                    <app-right-sidebar [Username]="Username"
                                       [UserID]="UserID">
                    </app-right-sidebar>
                </div>
            </div>
        </div>
    </div>
</div>
